module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addDate":"When","addNote":"Note","deleteError":"Error deleting Reminder"},"fr":{"addDate":"Quand","addNote":"Note","deleteError":"Erreur de suppression du rappel"}}')
  delete Component.options._Ctor
}
